import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_LOADERS } from '../../store/reception/reception-types.store';

const ReceptionStore= namespace(RECEPTION_MODULE_NAMESPACE)

@Component
class OrderByComponent extends Vue {

  @Prop({ default: () => [], type: [Array] })
  orderbyKeys: string[]
  @Prop({ default: () => [], type: [Array] })
  orderbyValue: number[]
  @Prop({ default: false, type: [Boolean] })
  solo: boolean

  dtCurrent: { value: number, index: number };
  /**
   *
   */
  constructor() {
    super();
    this.dtCurrent = { value: -1, index: 0 }
  }

  @ReceptionStore.Getter('loaders') reception_loaders: Map<string,boolean>

  get coOrderbyKeys(): string[] {
    return this.orderbyKeys;
  }
  get classes(): string[] {
    return this.solo ? ['order-by__menu--solo'] : []
  }
  get coOrderbyValues(): number[] {
    if (this.orderbyValue.length === 0) {
      return this.orderbyKeys.map(x => -1);
    }
    return this.orderbyValue;
  }

  get orderText(): string {
    let icon = this.coOrderbyValues[this.dtCurrent.index] === -1 ? "keyboard_arrow_down" : "keyboard_arrow_up";
    return `${this.$t(this.getTranslationKey(this.orderbyKeys[this.dtCurrent.index]))}`;
  }
  get orderIcon(): string {
    return this.coOrderbyValues[this.dtCurrent.index] === -1 ? "keyboard_arrow_down" : "keyboard_arrow_up";
  }
  get coLoader(): boolean {
    return this.reception_loaders.get(RECEPTION_LOADERS.FILTERS)
  }

  handleChangeSortType(index: number) {

    const cloned: number[] = JSON.parse(JSON.stringify(this.coOrderbyValues));
    cloned[index] = this.coOrderbyValues[index] === -1 ? 1 : -1;
    this.dtCurrent = { index: index, value: cloned[index] }
    this.$emit('update:orderbyValue', cloned)
  }

  getSortTypeIcon(index: number) {
    return this.coOrderbyValues[index] === -1
      ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
  }
  getTranslationKey(key: string) {

    return `${this.$route.name}_${key}`.toUpperCase()
  }
}

export default OrderByComponent;



// WEBPACK FOOTER //
// ./src/components/orderby/index.ts